import React from 'react';
import QRCode from 'qrcode.react';

const BuyMeACoffeeWidget = ({ upiId, onClose }) => {
  // Constructing the UPI link
  const upiLink = `upi://pay?pa=${(upiId)}`;

  return (
    <div className="fixed w-full h-full top-0 left-0 z-10 inset-0 overflow-y-auto flex justify-center items-center bg-gray-800 bg-opacity-50">
      <div className="bg-white p-8 rounded-lg">
        <h3 className="text-lg font-semibold mb-4">If you find our app useful, consider making a donation!</h3>
        <QRCode value={upiLink} />
        <p className="mt-4">Scan the QR code above to make a payment!</p>
        <button
          className="mt-4 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default BuyMeACoffeeWidget;
